import { createContext } from 'react';

/**
 * Theme context object, kept in its own module so ThemeProvider.jsx exports only
 * a component — which is what React Fast Refresh needs to hot-reload a module
 * without discarding its state.
 */
export const ThemeContext = createContext(null);

/** localStorage key. Shared with public/theme-init.js. */
export const THEME_STORAGE_KEY = '1fi-theme';
